import { Box, Heading, VStack, Text, Button, BoxProps } from '@chakra-ui/react'
import React from 'react'

type VideoProps = {
  video: any
} & BoxProps
const Video: React.FC<VideoProps> = ({ video, ...rest }) => {
  const [expand, setExpand] = React.useState(false)
  return (
    <Box
      key={video?.id}
      justifyContent="space-between"
      alignItems="center"
      w="100%"
      borderRadius={0}
      overflow="hidden"
      border="1px solid"
      borderColor="gray.100"
      transition="all 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
      _hover={{ borderColor: 'gray.200', shadow: 'sm' }}
      {...rest}
    >
      <iframe
        width={290}
        height={160}
        src={video?.url || ''}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        style={{ display: 'block' }}
      ></iframe>
      <VStack spacing={2} w="100%" alignItems="flex-start" p={3}>
        <VStack alignItems="flex-start" spacing={1} w="100%">
          <Heading fontWeight="500" color="gray.900" fontSize="xs" letterSpacing="-0.01em">
            {video?.title}
          </Heading>
          <Box w="100%">
            <Text
              fontSize="xs"
              color="gray.500"
              noOfLines={expand ? undefined : 2}
              lineHeight="1.5"
            >
              {video?.description}
            </Text>
            <Button
              variant="unstyled"
              fontSize="10px"
              fontWeight="600"
              textTransform="uppercase"
              letterSpacing="0.08em"
              color="gray.400"
              m={0}
              p={0}
              h="auto"
              minW="auto"
              _hover={{ color: 'gray.900' }}
              onClick={() => {
                setExpand(!expand)
              }}
            >
              {expand ? 'Less' : 'More'}
            </Button>
          </Box>
        </VStack>
        <Text
          fontSize="9px"
          fontWeight="600"
          textTransform="uppercase"
          letterSpacing="0.1em"
          color="gray.400"
          borderBottom="1px solid"
          borderColor="gray.200"
          pb={0.5}
        >
          {video?.category.split('_').join(' ')}
        </Text>
      </VStack>
    </Box>
  )
}

export default Video
